"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Loader(_ref) {
  var _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? true : _ref$isLoading;

  if (isLoading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "loader-wrapper"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "lds-ring"
    }, /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null)));
  }

  return null;
}

Loader.propTypes = {
  isLoading: _propTypes.default.bool
};
var _default = Loader;
exports.default = _default;